<script>
  //Components
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";
  import LessonPage from "./components/LessonPage.svelte";
  import DownloadPage from "./components/DownloadPage.svelte";
  import DemoPage from "./components/DemoPage.svelte";

  //Shared
  import Tabs from "./shared/Tabs.svelte";
  import MobileWarning from "./shared/MobileWarning.svelte";

  //External
  import Modal from "svelte-simple-modal";

  //Localization
  import { _, setupI18n, isLocaleLoaded, locale } from "../scripts/i18n.js";
  import LanguageSelector from "./shared/LanguageSelector.svelte";
  setupI18n({withLocale: "en"}); //{withLocale: "en"}

  let pages = ["Lessons", "Demo", "Downloads"];
  let activePage = "Lessons";
  $: if ($isLocaleLoaded) {
    pages = [$_("tab-0"), $_("tab-1"), $_("tab-2")];
    activePage = $_("tab-0");
  }

  const tabChange = (e) => {
    activePage = e.detail;
  };

  const mobileCheck = () => {
    let onMobile = false;
    if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      onMobile = true;
    }
    return onMobile;
  };
</script>


<LanguageSelector defaultVal={$locale} on:lang-changed={e => setupI18n({withLocale: e.detail})}/>
<Header />
<Tabs {activePage} {pages} on:tabChange={tabChange} />
<Modal>
  <main>
    {#if mobileCheck()}
      <MobileWarning />
    {:else if !$isLocaleLoaded}
      <p>Loading...</p>
    {:else}
      {#if activePage === $_("tab-0")}
        <LessonPage />
      {/if}
      {#if activePage === $_("tab-1")}
        <DemoPage />
      {/if}
      {#if activePage === $_("tab-2")}
        <DownloadPage />
      {/if}
    {/if}
  </main>
</Modal>
<!-- https://demo.wiris.com/mathtype/en/developers.php -->
<Footer />

<style>
  main {
    max-width: 960px;
    margin: 40px auto;
  }
</style>
